import { lazy, Suspense } from 'react';
import Spinner from '../features/Spinner';
import ErrorBoundary from '../components/ErrorBoundary';

// Lazy loading components
const Home = lazy(() => import('../components/Home'));
const Login = lazy(() => import('../components/Login'));
const ForgotPassword = lazy(() => import('../components/ForgotPassword'));
const ResetPassword = lazy(() => import('../components/ResetPassword'));
const Profile = lazy(() => import('../components/user/Profile'));
const Start = lazy(() => import('../components/Start'));
const Register = lazy(() => import('../components/Register'));
const Unauthorized = lazy(() => import('../components/Unauthorized'));
const ProfileSettings = lazy(() => import('../components/user/ProfileSettings'));
const OnboardingModal = lazy(() => import('../features/Onboarding/OnboardingModal'));

const withSuspense = (element) => (
  <Suspense fallback={<Spinner fullscreen />}>
    <ErrorBoundary>{element}</ErrorBoundary>
  </Suspense>
);

export const routeConfig = [
  // 🔓 Public routes
  { path: '/unauthorized', element: <Unauthorized />, isPrivate: false },
  { path: '*', element: <Home />, isPrivate: false },
  { path: '/home', element: <Home />, isPrivate: false },
  { path: '/login', element: withSuspense(<Login />), isPrivate: false },
  { path: '/register', element: <Register  />, isPrivate: false },
  { path: '/forgot-password', element: <ForgotPassword />, isPrivate: false },
  { path: '/reset-password/:token', element: <ResetPassword />, isPrivate: false },

  // 🔐 Private routes
  //{ path: '/onboarding', element: withSuspense(<OnboardingModal />), isPrivate: true, membershipTypes: ['NON_PREMIUM', 'PREMIUM', 'PREMIUM_PLUS'] },
  { path: '/start', element: withSuspense(<Start />), isPrivate: true, membershipTypes: ['NON_PREMIUM', 'PREMIUM', 'PREMIUM_PLUS'] },
  { path: '/profile', element: withSuspense(<ProfileSettings />), isPrivate: true, membershipTypes: ['NON_PREMIUM', 'PREMIUM', 'PREMIUM_PLUS'] },
  { path: '/profile/:id', element: withSuspense(<Profile />), isPrivate: true, membershipTypes: ['NON_PREMIUM', 'PREMIUM', 'PREMIUM_PLUS'] },
];